import { type SupabaseClient, createClient } from "@supabase/supabase-js";

let cached: { key: string; client: SupabaseClient } | null = null;

/**
 * The url and anon key arrive from /api/status rather than build-time env, so the web
 * build and both mobile bundles read the same source of truth. Both values are public.
 */
export function supabaseFor(url: string, anonKey: string) {
  const key = `${url}|${anonKey}`;
  if (cached?.key === key) return cached.client;

  const client = createClient(url, anonKey, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      // Sign-in is a 6-digit code, not a magic link, so there is never a token in the URL.
      detectSessionInUrl: false,
    },
  });

  cached = { key, client };
  return client;
}
